import React, { useCallback, useEffect, useState } from "react";
import { AspectRatio, Flex, FormControl, FormLabel, Input, Skeleton } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { PimcoreVideo, VideoSchema } from "./PimcoreVideo";
import { useFocus } from "./useFocus";
import { useAssetResolver, useContentManagement } from "./ContentManagementProvider";
import { SelectControl } from "./SelectControl";
import { ConsentBlock, openCM } from "../components/ConsentBlock";
import * as yup from "yup";
const schema = yup.object({
    asset: VideoSchema.nullable(),
    type: yup.string().required().oneOf(["asset", "youtube"]).default("youtube"),
    maxWidth: yup.string().required().default(""),
    youtubeId: yup.string().required().default(""),
    ratio: yup.number().required().default(16 / 9)
});
export const VideoContentElement = (props) => {
    var _a, _b, _c, _d, _e;
    const [ref, setRef] = useState(null);
    const [asset, setAsset] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const resolver = useAssetResolver();
    const { isEditing } = useContentManagement();
    const data = schema.cast((_a = props.contentElement.data) !== null && _a !== void 0 ? _a : {});
    useEffect(() => {
        var _a;
        if ((_a = data.asset) === null || _a === void 0 ? void 0 : _a.id) {
            resolver(data.asset.id, "WebLarge").then((asset) => setAsset(asset));
        }
    }, [props.contentElement]);
    const updateVideo = useCallback((assetInfo) => {
        props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, data), { asset: assetInfo }) }));
    }, [props.onChange, props.contentElement]);
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Video", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Type"),
                    React.createElement(SelectControl, { options: [
                            {
                                value: "asset",
                                label: "Asset"
                            },
                            {
                                value: "youtube",
                                label: "YouTube"
                            }
                        ], value: data.type, onChange: (type) => {
                            props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, data), { type: type.value }) }));
                        } })),
                data.type === "asset" ? (React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Video"),
                    React.createElement(PimcoreVideo, { data: (_b = data.asset) !== null && _b !== void 0 ? _b : VideoSchema.cast({}), onChange: updateVideo }))) : null,
                data.type === "youtube" ? (React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "YouTube ID"),
                    React.createElement(Input, { value: data.youtubeId, onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, data), { youtubeId: event.target.value }) })) }))) : null,
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Max Width"),
                    React.createElement(Input, { value: data.maxWidth, onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, data), { maxWidth: event.target.value }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Aspect Ratio"),
                    React.createElement(SelectControl, { options: [
                            {
                                value: JSON.stringify(16 / 9),
                                label: "16/9"
                            },
                            {
                                value: JSON.stringify(1),
                                label: "1/1"
                            },
                            {
                                value: JSON.stringify(9 / 16),
                                label: "9/16"
                            }
                        ], value: JSON.stringify(data.ratio), onChange: (type) => {
                            props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, data), { ratio: JSON.parse(type.value) }) }));
                        } }))),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center", w: "100%" },
            data.type === "youtube" && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "cookieconsent-optout-marketing" },
                    React.createElement(ConsentBlock, { title: "Wir benötigen Ihre Zustimmung.", description: "Dieser Inhalt stammt von einer externen Quelle.\n" +
                            "Um ihn zu sehen, müssen Sie Ihre Datenschutzeinstellungen anpassen und den Marketing-Cookies zustimmen.", action: () => openCM() })),
                React.createElement(AspectRatio, { className: "cookieconsent-optin-marketing", ratio: data.ratio, minH: 12, bg: "gray.50", w: "100%", maxWidth: (_c = data.maxWidth) !== null && _c !== void 0 ? _c : undefined },
                    React.createElement("iframe", { style: { pointerEvents: isEditing ? "none" : undefined }, src: "https://www.youtube.com/embed/" + data.youtubeId, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true })))),
            data.type === "asset" && (React.createElement(AspectRatio, { ratio: data.ratio, minH: 12, bg: "gray.50", w: "100%", maxWidth: (_d = data.maxWidth) !== null && _d !== void 0 ? _d : undefined }, asset ? (React.createElement("video", { controls: true, style: { pointerEvents: isEditing ? "none" : undefined, objectFit: "contain" }, poster: (_e = asset.videoPoster) !== null && _e !== void 0 ? _e : undefined },
                React.createElement("source", { src: asset.url, type: "video/mp4" }))) : React.createElement(Skeleton, null))))));
};
